import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "i18n";

import OrganizationFilter from "./OrganizationFilter";
import OrganizationList from "./OrganizationList";
import { ICONS } from "../Common/Icons";
import {
  setCurrentNavPage,
  setOrganizationListPaginationPage,
  setOrganizationListFilterTitle,
  setOrganizationListFilterConfigState,
  setOrganizationListFilterYear,
  setOrganizationListFilterPresentations,
  setOrganizationListFilterImportedBalance
  // initOrganizationListFilter
} from "actions";
import { fetchOrganizations } from "Thunks";

import { selectCurrentOrganization, selectCurrentNavPage } from "Selectors";
import TTPPaginator from "../Common/TTPPaginator";
import PageHeader from "../Common/PageHeader/PageHeader";
import { Select } from "antd";
import CardsContainer from "./CardsContainer";
import { NotificationBar } from "../Common/Notification/NotificationBar";
import NotificationApi from "../../services/NotificationServices";
import { inIframe } from "../../utils";
const { Option } = Select;

class ClientListPage extends Component {
  collaboratorId;
  constructor(props) {
    super(props);

    this.state = {
      showAssociationModal: false,
      year: "",
      years: [],
      searchedValue: "",
      loadingNotification: false,
      closeNotification: false,
      notificationsImportedBalance: "",
      isFilterSharedBalanceActivated: false,
      clientIds: [],
      cardsFetching: false
    };
    const searchParams = new URLSearchParams(window.location.search);
    let collabId = searchParams.get("collaboratorId") || null;
    this.collaboratorId = collabId;
  }
  componentDidMount() {
    const { dispatch } = this.props;
    this.handleGetNotificationImportedBalance();
    dispatch(setOrganizationListFilterImportedBalance([]));
  }
  componentWillMount() {
    const { dispatch, filter } = this.props;
    const url = new URL(window.location);
    if (filter.collaborators.length) {
      url.searchParams.set("collaboratorId", filter.collaborators[0].value);
    }

    if (filter.year && !url.searchParams.get("year")) {
      url.searchParams.set("year", filter.year);
    } else if (url.searchParams.get("year")) {
      dispatch(setOrganizationListFilterYear(url.searchParams.get("year")));
    }
    window.history.replaceState(null, "", url.toString());
    dispatch(setCurrentNavPage("CLIENTS_LIST"));
    this.props.dispatch(setOrganizationListFilterTitle(""));

    let year = new Date().getFullYear();
    this.state.years.push(year);
    this.setState({ year: url.searchParams.get("year") || year - 1 });
    for (let i = 0; i < 4; i++) {
      year--;
      this.state.years.push(year);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { filter, paginationPage, pageSize, synchro } = prevProps;
    if (
      (filter !== this.props.filter ||
        paginationPage !== this.props.paginationPage ||
        pageSize !== this.props.pageSize ||
        synchro !== this.props.synchro) &&
      this.props.synchro !== null
    ) {
      this.props.dispatch(fetchOrganizations(this.props.synchro));
    }
  }

  componentWillUnmount() {
    let url = window.location.toString();
    if (url.includes("?")) {
      url = url.split("?")[0];
    }
    if (window.location.pathname !== "/folders") {
      window.history.replaceState(null, "", url);
    }
  }

  handleOrganizationListPageChange = ({ selected }) => {
    this.props.dispatch(setOrganizationListPaginationPage(selected + 1));
  };

  renderPaginate() {
    let { organizations, paginationPage, pageSize } = this.props;
    if (organizations.error != null && organizations.error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleOrganizationListPageChange}
        pageSize={pageSize}
        nbResult={organizations.nbResult}
        paginationPage={paginationPage}
      />
    );
  }

  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  handleChangeSearchedValue = isVisible => {
    this.setState({ searchedValue: isVisible });
  };
  handleChangeClientIds = clientIds => {
    this.setState({ clientIds: clientIds });
  };
  handleChangeCardsFetching = cardsFetching => {
    this.setState({ cardsFetching: cardsFetching });
  };

  handleYearChange = value => {
    this.setState({ year: value });
    this.props.dispatch(setOrganizationListFilterYear(value));

    const url = new URL(window.location);
    url.searchParams.set("year", value);
    window.history.replaceState(null, "", url.toString());
  };
  handleOrganizationListFilterConfigState = selected => {
    this.props.dispatch(setOrganizationListFilterConfigState(selected));
  };
  handlePresentationStatusChange = selected => {
    this.props.dispatch(setOrganizationListFilterPresentations(selected));
  };

  handleGetNotificationImportedBalance() {
    this.setState({ loadingNotification: true });
    const { currentOrganization, user } = this.props;

    NotificationApi.getNotificationBalanceImported(
      user.id,
      currentOrganization.uen
    ).then(response => {
      this.setState({
        notificationsImportedBalance: response.data.data,
        loadingNotification: false
      });
    });
  }
  handleCloseNotification = () => {
    const { dispatch, currentOrganization, user } = this.props;
    NotificationApi.closeNotification(
      user.id,
      currentOrganization.uen,
      "UPLOAD_BALANCE"
    ).then(response => {
      this.setState({
        closeNotification: true
      });
      if (this.state.isFilterSharedBalanceActivated) {
        dispatch(setOrganizationListFilterImportedBalance([]));
      }
      this.handleChangeClientIds([]);
    });
  };
  handleSharedBalanceList = () => {
    const { dispatch } = this.props;
    this.setState({
      isFilterSharedBalanceActivated: true
    });
    this.handleChangeClientIds(
      this.state.notificationsImportedBalance.clientIds
    );
    dispatch(
      setOrganizationListFilterImportedBalance(
        this.state.notificationsImportedBalance.clientIds
      )
    );
  };
  render() {
    let filterFormIsVisible = false;
    let {
      organizations,
      organization,
      synchro,
      user,
      spaceAs,
      withoutHeader,
      filter
    } = this.props;
    let {
      closeNotification,
      notificationsImportedBalance,
      loadingNotification,
      cardsFetching
    } = this.state;

    return (
      <div
        className="page-content"
        style={{
          padding: withoutHeader ? "0px 0px 4.3rem 50px" : "0 0 4.3rem 0",
          backgroundColor: "#fafbfb"
        }}
      >
        {inIframe() === false && (
          <div
            style={{
              marginBottom: "10px"
            }}
          >
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        {!closeNotification &&
          notificationsImportedBalance &&
          !loadingNotification &&
          notificationsImportedBalance.notifications.length > 0 && (
            <div
              style={{
                marginLeft: withoutHeader ? "-50px" : ""
              }}
            >
              <NotificationBar
                message={
                  notificationsImportedBalance.count.includes(1)
                    ? _("notifyNewImportedBalance") +
                      " '" +
                      notificationsImportedBalance.notifications[0].client +
                      "'" +
                      _("notifyAtYourDisposal")
                    : notificationsImportedBalance.count[0] +
                      _("notifyNewImportedBalances")
                }
                theme="greenTeal"
                onClose={this.handleCloseNotification}
                onSeeMore={this.handleSharedBalanceList}
              />
            </div>
          )}
        <PageHeader
          header="clientsList"
          subHeader="clientsListSubHeader"
          icon={ICONS.CLIENTS_LIST}
        >
          <Select
            defaultValue={this.state.year}
            id={"select_ant"}
            style={{
              width: 105,
              color: "white",
              height: 35,
              backgroundColor: "#6d7f92",
              padding: "4px",
              borderRadius: "19px",
              marginTop: "2.5px"
            }}
            onChange={this.handleYearChange}
          >
            {this.state.years.map((item, i) => {
              return (
                <Option value={item} key={i}>
                  {item}
                </Option>
              );
            })}
          </Select>
        </PageHeader>
        <CardsContainer
          organization={organization}
          filterCollaborator={filter.collaborators}
          spaceAs={spaceAs}
          user={user}
          year={this.state.year}
          synchro={synchro}
          handleOrganizationListFilterConfigState={
            this.handleOrganizationListFilterConfigState
          }
          configState={this.props.organizationsFilter.configState}
          filtersClientCRMGroupe={this.props.organizationsFilter.clientCRMGroup}
          filtersClientCRMType={this.props.organizationsFilter.clientCRMTypes}
          filtersjuridicalForms={this.props.organizationsFilter.juridicalForms}
          filterRoleCollaborateur={
            this.props.organizationsFilter.roleCollaborator
          }
          searchedValue={this.state.searchedValue}
          clientIds={this.state.clientIds}
          handleChangeCardsFetching={this.handleChangeCardsFetching}
        />
        <OrganizationFilter
          filterFormIsVisible={this.handleFilterFormIsVisible}
          presentationStatusChange={this.handlePresentationStatusChange}
          presentationState={this.props.organizationsFilter.presentationState}
          collaboratorId={this.collaboratorId}
          changeSearchedValue={this.handleChangeSearchedValue}
          cardsFetching={cardsFetching}
        />
        <div
          className={`row align-center medium-11 ${filterFormIsVisible &&
            "add-margin-left"}`}
        >
          <OrganizationList
            organizations={organizations}
            year={this.state.year}
            cardsFetching={cardsFetching}
          />
        </div>
        <div
          className={`row align-center margin-bottom-2 ${filterFormIsVisible &&
            "add-margin-left"}`}
        >
          <div
            className={
              filterFormIsVisible ? "column medium-12" : "column medium-11"
            }
          >
            {organizations.fetched && organizations.items.length ? (
              this.renderPaginate()
            ) : (
              <div className="row pagination" />
            )}
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  organization: state.auth.currentOrganization.uen,
  organizationsFilter: state.organizations.list.filter,
  currentOrganization: selectCurrentOrganization(state),
  organizations: state.organizations.list,
  paginationPage: state.organizations.list.paginationPage,
  pageSize: state.organizations.list.pageSize,
  filter: state.organizations.list.filter,
  spaceAs: state.auth.spaceAs,
  preferences: state.auth.preferences,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro,
  user: state.auth.user,
  withoutHeader: state.auth.withoutHeader,
  currentNavPage: selectCurrentNavPage(state)
});

export default connect(mapStateToProps)(ClientListPage);



// WEBPACK FOOTER //
// ./src/components/OrganizationList/ClientListPage.js